import React, { useState } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { Player } from "video-react";
import videoPoster from "../../../Imgs/HomePage/videoPoster.jpg";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/MultiMedia/MultiMedia.css";

const multiMediaCard = {
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  backgroundColor: "#fff",
  opacity: "95%",
};

const active = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#fff",
  backgroundColor: "#186491",
  fontSize: ".75em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};
const deactive = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#186491",
  backgroundColor: "#fff",
  fontSize: ".75em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};
const activeTablet = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#fff",
  backgroundColor: "#186491",
  fontSize: ".8em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};
const deactiveTablet = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#186491",
  backgroundColor: "#fff",
  fontSize: ".8em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};
const activeMobile = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#fff",
  backgroundColor: "#186491",
  fontSize: ".8em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};
const deactiveMobile = {
  textDecoration: "none",
  display: "inline-block",
  borderRadius: "100px",
  padding: "5.5px 10px",
  transition: "all .2s",
  position: "relative",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#186491",
  backgroundColor: "#fff",
  fontSize: ".8em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};

const VideoGallery = (props) => {
  const [videos, setVideos] = useState([]);

  const getVideos = useAxios({
    url: `${API_URL}/Multimedia_Service/`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log(
          "data",
          res.data.filter((item) => item.content_type === 0)
        );
        setVideos(res.data.filter((item) => item.content_type === 0));
      }
    },
  });
  return props.size === "laptopdesktop" ? (
    <div className="multiMediaBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p
            className="mainTitle mainTitleBorderRight mainTitleBorderLeft"
            style={{ color: "#f9f9f9" }}
          >
            <strong>محصولات چند رسانه ای</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription" style={{ color: "#fff" }}>
              ایرانیان پوشش به روایت تصاویر و رسانه
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={3}></Col>
        <Col span={18}>
          <div style={multiMediaCard}>
            <Row
              style={{
                direction: "rtl",
                textAlign: "right",
                borderRadius: "20px",
              }}
            >
              <Col
                span={4}
                style={{
                  backgroundColor: "#f9f9f9",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={4}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("imagegallery")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    گالری تصاویر
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("videogallery")}
                    class="activeBtn activeBtn-white activeBtn-animated"
                    style={active}
                  >
                    گالری ویدیو
                  </a>
                </Center>

                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("news")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    مطبوعات
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    href="http://moraghebbime.ir/%d8%b1%d8%a7%d8%af%db%8c%d9%88-%d8%a8%db%8c%d9%85%d9%87/"
                    target="_blank"
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    رادیو ما
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    href="https://www.aparat.com/iranianpooshesh"
                    target="_blank"
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    آپارات
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("13azar")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    ۱۳ آذر روز بیمه
                  </a>
                </Center>
                {/* <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("norooz")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactive}
                  >
                    نوروز ۱۴۰۱
                  </a>
                </Center> */}
              </Col>
              <Col span={1}></Col>
              <Col span={18}>
                <Center>
                  <Margin top={4}>
                    <div>
                      <p className="cardTitle">
                        <strong>گالری ویدیو</strong>
                      </p>
                    </div>
                  </Margin>
                </Center>
                <Center>
                  <hr className="cardTitleHR" />
                </Center>
                <Margin top={3}></Margin>
                <Row>
                  {getVideos.response?.data &&
                    videos.map((item, index) => {
                      return [
                        <>
                          <Col span={2}></Col>
                          <Col span={9}>
                            <Player
                              className="videoStyle"
                              playsInline
                              poster={item.image}
                              src={item.file}
                            />
                            <Center>
                              <p className="textParagraph">
                                {item.description == "undefined"
                                  ? ""
                                  : item.description}
                              </p>
                            </Center>
                            <Margin top={3}></Margin>
                          </Col>

                          {index % 2 !== 0 ? <Col span={2}></Col> : undefined}
                        </>,
                      ];
                    })}
                </Row>
              </Col>
              <Col span={1}></Col>
            </Row>
          </div>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="multiMediaBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p
            className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"
            style={{ color: "#f9f9f9" }}
          >
            <strong>محصولات چند رسانه ای</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription" style={{ color: "#fff" }}>
              ایرانیان پوشش به روایت تصاویر و رسانه
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={multiMediaCard}>
            <Row
              style={{
                direction: "rtl",
                textAlign: "right",
                borderRadius: "20px",
              }}
            >
              <Col
                span={6}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={4}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("imagegallery")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactiveTablet}
                  >
                    گالری تصاویر
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("videogallery")}
                    class="activeBtn activeBtn-white activeBtn-animated"
                    style={activeTablet}
                  >
                    گالری ویدیو
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("news")}
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactiveTablet}
                  >
                    مطبوعات
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    href="http://moraghebbime.ir/%d8%b1%d8%a7%d8%af%db%8c%d9%88-%d8%a8%db%8c%d9%85%d9%87/"
                    target="_blank"
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactiveTablet}
                  >
                    رادیو ما
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    href="https://www.aparat.com/iranianpooshesh"
                    target="_blank"
                    class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
                    style={deactiveTablet}
                  >
                    آپارات
                  </a>
                </Center>
                <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("13azar")}
                    class="activeBtn activeBtn-white activeBtn-animated"
                    style={deactiveTablet}
                  >
                    ۱۳ آذر روز بیمه
                  </a>
                </Center>
                {/* <Margin top={3}></Margin>
                <Center>
                  <a
                    onClick={() => props.history.push("norooz")}
                    class="activeBtn activeBtn-white activeBtn-animated"
                    style={deactiveTablet}
                  >
                    نوروز ۱۴۰۱
                  </a>
                </Center> */}
              </Col>
              <Col span={1}></Col>
              <Col span={16}>
                <Center>
                  <Margin top={3}>
                    <div>
                      <p className="cardTitleTablet">
                        <strong>گالری ویدیو</strong>
                      </p>
                    </div>
                  </Margin>
                </Center>
                <Center>
                  <hr className="cardTitleHRTablet" />
                </Center>
                <Margin top={3}></Margin>
                <Row>
                  {getVideos.response?.data &&
                    videos.map((item, index) => {
                      return [
                        <>
                          <Col span={3}></Col>
                          <Col span={18}>
                            <Player
                              className="videoStyle"
                              playsInline
                              poster={item.image}
                              src={item.file}
                            />
                            <Center>
                              <p className="textParagraphTablet">
                                {item.description == "undefined"
                                  ? ""
                                  : item.description}
                              </p>
                            </Center>
                          </Col>

                          <Col span={3}></Col>
                        </>,
                      ];
                    })}
                </Row>
              </Col>
              <Col span={1}></Col>
            </Row>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  ) : (
    <div className="multiMediaBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p
            className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile"
            style={{ color: "#f9f9f9" }}
          >
            <strong>محصولات چندرسانه ای</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile" style={{ color: "#fff" }}>
              ایرانیان پوشش به روایت تصاویر و رسانه
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={11}></Col>
        <Col span={12} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            onClick={() => props.history.push("imagegallery")}
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
            گالری تصاویر
          </a>
          <Margin top={3}></Margin>
          <a
            onClick={() => props.history.push("videogallery")}
            class="activeBtn activeBtn-white activeBtn-animated"
            style={activeMobile}
          >
            گالری ویدیو
          </a>
          <Margin top={3}></Margin>
          <a
            onClick={() => props.history.push("news")}
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
            مطبوعات
          </a>
          <Margin top={3}></Margin>
          <a
            href="http://moraghebbime.ir/%d8%b1%d8%a7%d8%af%db%8c%d9%88-%d8%a8%db%8c%d9%85%d9%87/"
            target="_blank"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
            رادیو ما
          </a>
          <Margin top={3}></Margin>
          <a
            href="https://www.aparat.com/iranianpooshesh"
            target="_blank"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
            آپارات
          </a>
          <Margin top={3}></Margin>
          <a
            onClick={() => props.history.push("13azar")}
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
            ۱۳ آذر روز بیمه
          </a>
          {/* <Margin top={3}></Margin>
          <a
            onClick={() => props.history.push("norooz")}
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            style={deactiveMobile}
          >
           نوروز ۱۴۰۱
          </a> */}
        </Col>
        <Col span={1}></Col>
      </Row>
      <Margin top={3}></Margin>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={multiMediaCard}>
            <Center>
              <div>
                <Margin top={3}>
                  <p className="cardTitleMobile">
                    <strong>گالری ویدیو</strong>
                  </p>
                </Margin>
              </div>
            </Center>
            <Center>
              <div className="cardTitleHR"></div>
            </Center>
            <Margin top={3}></Margin>
            <Row>
              <Col span={1}></Col>
              <Col span={22}>
                <Row>
                  {getVideos.response?.data &&
                    videos.map((item, index) => {
                      return [
                        <>
                          <Col span={24}>
                            <Player
                              className="videoStyle"
                              playsInline
                              poster={item.image}
                              src={item.file}
                            />
                            <Center>
                              <p className="textParagraphMobile">
                                {item.description == "undefined"
                                  ? ""
                                  : item.description}
                              </p>
                            </Center>
                            <Margin top={3}></Margin>
                          </Col>
                        </>,
                      ];
                    })}
                </Row>
              </Col>
              <Col span={1}></Col>
            </Row>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default VideoGallery;
